import { render, staticRenderFns } from "./SellerInfoCard.vue?vue&type=template&id=baea7b12&scoped=true"
import script from "./SellerInfoCard.vue?vue&type=script&lang=js"
export * from "./SellerInfoCard.vue?vue&type=script&lang=js"
import style0 from "./SellerInfoCard.vue?vue&type=style&index=0&id=baea7b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baea7b12",
  null
  
)

export default component.exports